var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCaja = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "158px",
    height: "76px",
    viewBox: "0 0 158 76",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "8BF00669-49AD-400D-8D2B-FE85DF5F02FD")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Inicio",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-93.000000, -625.000000)",
    id: "second_bar"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Caja-seca",
    transform: "translate(0.000000, 534.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "caja",
    transform: "translate(93.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.967391,0 L2.07601563,0 C1.06810122,0 0.25,0.818101223 0.25,1.82601562 L0.25,53.2608696 C0.25,54.2707099 1.06810122,55.0868852 2.07601563,55.0868852 L16.6847826,55.0868852 L16.6847826,51.4346399 L3.90224524,51.4346399 L3.90224524,3.65203125 L150.141376,3.65203125 L150.141376,51.4346399 L13.9455808,51.4346399 L13.9455808,55.0868852 L151.967391,55.0868852 C152.977232,55.0868852 153.793407,54.2707099 153.793407,53.2608696 L153.793407,1.82601563 C153.793407,0.818101223 152.977232,0 151.967391,0 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "2.07601562 44.1303635 13.0325374 44.1303635 13.0325374 47.7826087 2.07601562 47.7826087"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(15.478261, 62.347862) rotate(-270.000000) translate(-15.478261, -62.347862) ",
    x: 7.47826087,
    y: 60.5217391,
    width: 16,
    height: 3.65224524
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(27.500000, 56.826123) rotate(-270.000000) translate(-27.500000, -56.826123) ",
    x: 24,
    y: 55,
    width: 7,
    height: 3.65224524
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 116,
    y: 60,
    width: 11,
    height: 3.65224524
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 88,
    y: 60,
    width: 11,
    height: 3.65224524
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(84.695070, 57.764787) rotate(-315.000000) translate(-84.695070, -57.764787) ",
    points: "78.1950696 55.9386649 91.1950696 55.9386649 91.1950696 59.5909101 78.1950696 59.5909101"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 143,
    y: 60,
    width: 11,
    height: 3.65224524
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(151.967284, 57.836550) rotate(-270.000000) translate(-151.967284, -57.836550) ",
    points: "146.467284 56.010427 157.467284 56.010427 157.467284 59.6626723 146.467284 59.6626723"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "133.419946 62.4 137.285836 62.4 137.285836 66.2571429 133.419946 66.2571429"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4.1,
    cx: 135.441837,
    cy: 64.425,
    rx: 9.49183673,
    ry: 9.475
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "104.419946 62.4 108.285836 62.4 108.285836 66.2571429 104.419946 66.2571429"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    strokeWidth: 4.1,
    cx: 106.441837,
    cy: 64.425,
    rx: 9.49183673,
    ry: 9.475
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    transform: "translate(155.500000, 63.663061) rotate(-270.000000) translate(-155.500000, -63.663061) ",
    points: "151.836939 61.8369387 159.163061 61.8369387 159.163061 65.4891839 151.836939 65.4891839"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "17.5978261 44.1303635 150.141376 44.1303635 150.141376 47.7826087 17.5978261 47.7826087"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "7.55427649 7.30427649 151.967391 7.30427649 151.967391 10.9565217 7.55427649 10.9565217"
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCaja, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/caja.5c4c15aa.svg";
export { ForwardRef as ReactComponent };